import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { CoordinationDescriptionView } from './actionsview';
import { CancelledCoordinationCardDetailsSettingsTab as SettingsTab } from './cancelledsettings';

export const CancelledCoordinationCardDetailsSettingsTabView = SuperCritical(({ model: m } : { model : SettingsTab }) =>
    <div className="cancelledcoordinationcarddetailssettingstab">
        <CoordinationDescriptionView coordination={m.CoordinationCard.Coordination} />
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/cancelledsettingsview.tsx